module.exports = "请尽可能详尽地说明这个需求的用例和场景。最重要的是：解释清楚是怎样的**用户体验需求**催生了这个功能上的需求。\n\nAnt Design Vue 的一个重要设计原则是保持 API 的简洁和直接。通常来说，我们只考虑添加在现有的 API 下无法轻松实现的功能。新功能的用例也应当足够常见。\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh/motivationHelp.md
// module id = 501
// module chunks = 0